module.exports = __webpack_public_path__ + "static/media/umb-blue-logo.41203724.svg";